export default __webpack_public_path__ + "static/media/rawpixel-com.b4cd41a2.jpg";